import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';

import {
  searchCostCodes,
  createCostCode,
  editCostCode,
  getCostCodeSelectList,
  makeActive,
  makeInActive
} from './api';
import * as CostCodeActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* searchAsync(action) {
  const result = yield call(searchCostCodes, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: CostCodeActionType.SEARCH_COST_CODE_SUCCESS,
        data: { data: result.data, params: action.params }
      })
    ];
  } else {
    yield [
      put({
        type: NotifyActionType.NOTIFY_ERROR,
        data: result.data.error
      }),
      put({
        type: CostCodeActionType.SEARCH_COST_CODE_FAIL
      })
    ];
  }
}

export function* createAsync(action) {
  const result = yield call(createCostCode, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: 'Cost code added.'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: CostCodeActionType.CREATE_COST_CODE_ERROR,
      data: result.data.error
    });
  }
}

export function* editAsync(action) {
  const result = yield call(editCostCode, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: 'Cost code saved.'
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: CostCodeActionType.EDIT_COST_CODE_ERROR,
      data: result.data.error
    });
  }
}

export function* getCostCodeSelectListAsync(action) {
  const result = yield call(getCostCodeSelectList);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: CostCodeActionType.GET_COST_CODE_SELECT_LIST_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: CostCodeActionType.GET_COST_CODE_SELECT_LIST_ERROR,
      data: result.data.error
    });
  }
}

export function* makeActiveAsync(action) {
  const result = yield call(makeActive, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved.' });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error
    });
  }
}

export function* makeInActiveAsync(action) {
  const result = yield call(makeInActive, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved.' });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data.error
    });
  }
}

export default function* WatchWorkOrder() {
  yield all([
    takeLatest(CostCodeActionType.SEARCH_COST_CODE_ASYNC, searchAsync),
    takeLatest(CostCodeActionType.CREATE_COST_CODE_ASYNC, createAsync),
    takeLatest(CostCodeActionType.EDIT_COST_CODE_ASYNC, editAsync),
    takeLatest(
      CostCodeActionType.GET_COST_CODE_SELECT_LIST_ASYNC,
      getCostCodeSelectListAsync
    ),
    takeLatest(CostCodeActionType.MAKE_COST_CODE_ACTIVE_ASYNC, makeActiveAsync),
    takeLatest(
      CostCodeActionType.MAKE_COST_CODE_INACTIVE_ASYNC,
      makeInActiveAsync
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/CostCodes/saga.js